/**
 * WHICH CLIENT produced a tracking event (demand-funnel views/impressions).
 * Single SoT for the variant dimension (same pattern as
 * `LISTING_VIEW_SURFACES` / `IMPRESSION_SURFACES`) — the DB CHECK
 * constraints on `listing_view_events.client` /
 * `listing_impression_events.client`, both request schemas, the mobile
 * emitters and both routes' server defaults all reference these literals.
 *
 * Optional on the wire; the SERVER defaults omitted -> 'web' so every
 * pre-client web beacon stays valid unchanged (web builders deliberately
 * keep omitting it). The mobile emitters ALWAYS send 'mobile'.
 * Client-asserted and therefore spoofable — accepted for a trend metric,
 * same rationale as `guestId` (see track-listing-view.ts header).
 *
 * @see .tondocs/product/HANDOFF_MOBILE_TRACKING_2026_07_14.md §1
 */

export const TRACKING_CLIENTS = ["web", "mobile"] as const;
export type TrackingClient = (typeof TRACKING_CLIENTS)[number];
